import React, {useEffect, useState} from 'react';

const ON_CHANGE_TIMEOUT = 100;

const DelayedInput = (props, ref) => {

  const {
    Component,
    value: externalValue,
    onChange
  } = props;

  const [value, setValue] = useState(null);
  const [timeoutId, setTimeoutId] = useState(null);

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    }
  }, []);

  useEffect(() => {
    if (externalValue !== null && externalValue !== undefined && value === null) {
      setValue(externalValue);
    }
  }, [externalValue]);

  const callOnChange = value => {
    setValue(value);

    if (onChange) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      setTimeoutId(setTimeout(
        () => onChange(value),
        ON_CHANGE_TIMEOUT
      ));
    }
  };

  const componentProps = Object.assign({}, props);
  delete componentProps.Component;
  delete componentProps.getValueFromEvent;

  const getValueFromEvent = props.getValueFromEvent || (e => e.target ? e.target.value : e);

  return (
    <Component
      {...componentProps}
      ref={ref}
      value={value}
      onChange={e => callOnChange(getValueFromEvent(e))}
    />
  );
};

export default React.forwardRef(DelayedInput);



// WEBPACK FOOTER //
// ./src/components/delayed-input/index.jsx